import { getEnumValues } from './get-enum-values';
export enum ImageMimeTypes{
	PNG='image/png',
	JPEG='image/jpeg',
	GIF='image/gif',
	SVG='image/svg+xml',
}
export const ImageMimeTypesValues = getEnumValues<ImageMimeTypes>(ImageMimeTypes);
